import {
  ArenaCacheDetailResponseBoundarySchema,
  ArenaCacheListItemBoundarySchema,
  ArenaCacheListResponseBoundarySchema,
  ArenaCacheParticipantSchema as ContractArenaCacheParticipantSchema,
  parseArenaCacheDetailResponse,
  parseArenaCacheListResponse,
} from '@sweetistics/contracts/arena';
import type { z } from 'zod';

export const ArenaCacheParticipantSchema = ContractArenaCacheParticipantSchema;

export const ArenaCacheListItemSchema = ArenaCacheListItemBoundarySchema;

export const ArenaCacheListResponseSchema = ArenaCacheListResponseBoundarySchema;

export type ArenaCacheParticipant = z.infer<typeof ArenaCacheParticipantSchema>;
export type ArenaCacheListItem = z.infer<typeof ArenaCacheListItemSchema>;
export type ArenaCacheListResponse = z.infer<typeof ArenaCacheListResponseSchema>;

export function serializeArenaCacheListResponse(payload: ArenaCacheListResponse): ArenaCacheListResponse {
  return parseArenaCacheListResponse(payload);
}

export const ArenaCacheDetailResponseSchema = ArenaCacheDetailResponseBoundarySchema;

export type ArenaCacheDetailResponse = z.infer<typeof ArenaCacheDetailResponseSchema>;

export function serializeArenaCacheDetailResponse(payload: ArenaCacheDetailResponse): ArenaCacheDetailResponse {
  return parseArenaCacheDetailResponse(payload);
}
